import {
  RouteLocationNormalized,
  RouteLocationRaw,
  useRouter,
} from "vue-router";

const HISTORY_KEY = "__route_history__";

// Инициализация истории в объекте window
if (!window[HISTORY_KEY]) {
  window[HISTORY_KEY] = [];
}

/**
 * Получить текущую историю маршрутов из window[HISTORY_KEY].
 */
const getRouteHistory = (): RouteLocationNormalized[] => {
  return window[HISTORY_KEY] as RouteLocationNormalized[];
};

/**
 * Установить новое состояние истории в window[HISTORY_KEY].
 */
const setRouteHistory = (history: RouteLocationNormalized[]) => {
  window[HISTORY_KEY] = history;
};

/**
 * Добавить маршрут в историю.
 */
const addRouteToHistory = (route: RouteLocationNormalized) => {
  const history = getRouteHistory();
  history.push(route);
  setRouteHistory(history);
};

/**
 * Удалить последний маршрут из истории.
 */
const removeLastRoute = (): RouteLocationNormalized | null => {
  const history = getRouteHistory();
  const lastRoute = history.pop() || null;
  setRouteHistory(history);
  return lastRoute;
};

/**
 * Переход назад по истории.
 */
const back = (fallback: RouteLocationRaw = { path: "/" }) => {
  const router = useRouter();
  const previousRoute = removeLastRoute();
  if (previousRoute) {
    router.push(previousRoute.fullPath);
  } else {
    router.push(fallback);
  }
};

/**История роутов */
export const useRouteHistory = () => {
  return {
    /**Установить новое состояние истории в window[HISTORY_KEY] */
    setRouteHistory,
    /**Добавить маршрут в историю */
    addRouteToHistory,
    /**Переход назад по истории */
    back,
  };
};
